export default __webpack_public_path__ + "static/media/lift2.17da1d52.jpeg";